/*
IMPORTANT - This enum translates to the KeyIndicatorType in the core library for the back-end's use!
 */
export enum KeyIndicatorType {
  SALES_SQFT = 'SALES_SQFT',
  SALES_VOLUME = 'SALES_VOLUME',
  STORE_COUNT = 'STORE_COUNT'
}
